import { produce } from 'immer'
import { ExpenseReportsFiltersBody } from 'src/components/ExpenseReportsBox/ExpenseReportsBox'
import { PaginationResponse } from 'src/models/pagination.models'
import {
  SET_IS_DOWNLOAD_EXPENSE_REPORTS_PAID_POPUP_OPEN,
  SetIsDownloadExpenseReportsPaidPopupOpenAction,
} from 'src/redux/actions/app.actions'
import {
  DELETE_EXPENSE_REPORTS_SUCCESS,
  DeleteExpenseReportsActions,
  GET_APPROVER_EXPENSE_REPORTS_FAILURE,
  GET_APPROVER_EXPENSE_REPORTS_INIT,
  GET_APPROVER_EXPENSE_REPORTS_LENGTH_SUCCESS,
  GET_APPROVER_EXPENSE_REPORTS_SUCCESS,
  GetApproverExpenseReportsActions,
  GetApproverExpenseReportsLengthActions,
  POST_CREATE_EXPENSE_REPORT_SUCCESS,
  POST_MARK_EXPENSE_REPORTS_PAID_SUCCESS,
  PostCreateExpenseReportActions,
  PostMarkExpenseReportsPaidActions,
  SET_EMPTY_STATE_EXPENSE_REPORTS,
  SetEmptyStateExpenseReportsAction,
} from 'src/redux/actions/data/expenses.actions'
import {
  GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_FAILURE,
  GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_INIT,
  GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_SUCCESS,
  GetOrganizationOutOfPocketExpensesEnabledActions,
} from 'src/redux/actions/data/organizations.actions'

export interface ExpenseReportsFullPaginatedDataState {
  ids: string[]
  complete: boolean
  pagination?: PaginationResponse
  loading: boolean
  gettingOutOfPocketExpensesEnabled: boolean
  isEmpty: boolean
  selectedDownloadExpenseReports?: ExpenseReportsFiltersBody
}

export const initialState: ExpenseReportsFullPaginatedDataState = {
  ids: [],
  complete: false,
  loading: false,
  gettingOutOfPocketExpensesEnabled: false,
  isEmpty: true,
}

export type Actions =
  | PostCreateExpenseReportActions
  | GetApproverExpenseReportsActions
  | PostMarkExpenseReportsPaidActions
  | GetOrganizationOutOfPocketExpensesEnabledActions
  | SetEmptyStateExpenseReportsAction
  | SetIsDownloadExpenseReportsPaidPopupOpenAction
  | DeleteExpenseReportsActions
  | GetApproverExpenseReportsLengthActions

const OutOfPocketReportsAllReducer = (
  state = initialState,
  action: Actions,
): ExpenseReportsFullPaginatedDataState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_APPROVER_EXPENSE_REPORTS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_APPROVER_EXPENSE_REPORTS_SUCCESS: {
        draft.ids =
          action.payload.pagination.page === 0
            ? action.payload.expenseReports.map(
                (expenseReport) => expenseReport.id,
              )
            : [
                ...draft.ids,
                ...action.payload.expenseReports.map(
                  (expenseReport) => expenseReport.id,
                ),
              ]
        draft.loading = false
        draft.pagination = action.payload.pagination
        draft.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages
        return draft
      }

      case GET_APPROVER_EXPENSE_REPORTS_LENGTH_SUCCESS: {
        draft.isEmpty = action.payload.expenseReports.length === 0
        return draft
      }

      case SET_EMPTY_STATE_EXPENSE_REPORTS: {
        draft.isEmpty = false
        return draft
      }

      case GET_APPROVER_EXPENSE_REPORTS_FAILURE: {
        draft.loading = false
        draft.complete = true
        return draft
      }

      case POST_CREATE_EXPENSE_REPORT_SUCCESS: {
        draft.ids = [action.payload.id, ...draft.ids]
        return draft
      }

      case POST_MARK_EXPENSE_REPORTS_PAID_SUCCESS: {
        draft.ids = [
          ...draft.ids,
          ...action.payload.expenseReports.map(
            (expenseReport) => expenseReport.id,
          ),
        ]
        return draft
      }

      case DELETE_EXPENSE_REPORTS_SUCCESS: {
        draft.ids = draft.ids.filter(
          (id) => !action.payload.expenseReports.deleted.includes(id),
        )
        return draft
      }

      case GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_INIT: {
        draft.gettingOutOfPocketExpensesEnabled = true
        return draft
      }

      case GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_FAILURE:
      case GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_SUCCESS: {
        draft.gettingOutOfPocketExpensesEnabled = false
        return draft
      }

      case SET_IS_DOWNLOAD_EXPENSE_REPORTS_PAID_POPUP_OPEN: {
        draft.selectedDownloadExpenseReports = action.payload.filtersBody

        return draft
      }
    }
  })
}

export default OutOfPocketReportsAllReducer
